import BarcodeFilters from 'library/components/filters/barcode-filters';
import Loader from 'library/components/entity-loader';
import Image from 'library/components/image';
import withModalContainer from '../hocs/with-modal-container';
import {
  CatalogueContainer,
  CheckIcon,
  ExitingItem,
  ImageContainer,
  ExitingItemsContainer,
} from './styled';
import NoContent from '../../no-content';
import Search from '../../search';

const Catalogue = ({
  data = [],
  isLoading,
  hasMore = false,
  onLoadMore,
  onReset,
  onFilterChange,
  onQueryParamDelete,
  filters,
  query,
  selectedId,
  onChange,
  noContentMessage,
  isSubmitOnPickEnabled = false,
}) => {
  const renderItem = (item) => {
    const {
      id, images = [], description, category_id, category_name, manufacturer_id, ean, upc, manufacturer_name, barcode_params,
    } = item;
    const [image] = images;
    const stringifiedPrice = barcode_params?.find((el) => el?.name === 'retail_price')?.value;

    const handleChange = () => {
      onChange({
        ...(stringifiedPrice ? { price: parseFloat(stringifiedPrice) } : {}),
        id,
        name: description,
        category: category_id,
        manufacturer: manufacturer_id,
        category_name,
        barcode: ean || upc,
        images,
        manufacturer_name,
      });
    };

    return (
      <ExitingItem key={id} isSelected={selectedId === id} onClick={handleChange}>
        <ImageContainer>
          <Image isCover id={id} source={image} width={40} />
        </ImageContainer>
        <div>
          <span>{description}</span>
          <br />
          <span>{category_name}</span>
        </div>
        {
          isSubmitOnPickEnabled ? null : (<CheckIcon className={selectedId === id ? 'icon-check-selected' : 'icon-check'} />)
        }
      </ExitingItem>
    );
  };

  return (
    <CatalogueContainer>
      <Search
        hideOverlay
        queryParameter="query"
        onSelect={({ id, name }) => {
          onFilterChange({ [id]: name });
        }}
        loading={false}
        placeholder="Find an item"
        types={['item']}
        isFocusedOnMount
      />
      <BarcodeFilters
        showType={false}
        filters={filters}
        isShown
        baseQuery={query}
        onChange={onFilterChange}
        onReset={onReset}
        onDelete={onQueryParamDelete}
        isQueryFilterSibling={false}
        isLoading={isLoading}
      >
        <ExitingItemsContainer>
          <div>
            {data.map(renderItem)}
          </div>
          <Loader
            isLoading={isLoading}
            currentAmount={data.length}
            hasMore={hasMore}
            onScroll={onLoadMore}
            onReset={isSubmitOnPickEnabled ? undefined : onReset}
          />
          {data.length === 0 && !isLoading ? (
            <NoContent
              title={noContentMessage}
            />
          ) : null}
        </ExitingItemsContainer>
      </BarcodeFilters>
    </CatalogueContainer>
  );
};
export default withModalContainer(Catalogue);
